import { ReactElement, useCallback, useEffect } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { useRecoilValue } from 'recoil'
import { usersState } from '../../states/users-state'
import axios from 'axios'
import { getServerHost } from '../../utils/get-server-host'
import { getHeaders } from '../../utils/get-headers'
import { useNavigate } from 'react-router'
import { UserId } from '../../types/types'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

const UsersScreen = (): ReactElement => {
  const users = useRecoilValue(usersState)
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  const removeUser = useCallback(async (userId) => {
    await axios.delete(getServerHost(`user/${userId}`), {
      headers: getHeaders(),
    })
  }, [])

  const openUserDetail = useCallback((userId: UserId): void => {
    navigate(`${userId}`)
  }, [])

  return (
    <Flexbox isCol flex={1}>
      <ScreenTitle
        title={formatMessage({
          id: 'TITLE_USERS',
          defaultMessage: 'Users',
        })}>
        <Flexbox justifyContent="flex-end" flex={1}>
          <Link to={'add'} className="btn btn-primary btn-sm">
            Add
          </Link>
        </Flexbox>
      </ScreenTitle>

      <table className="table table-compact w-full">
        <thead>
          <tr>
            <th></th>
            <th>First name</th>
            <th>Last name</th>
            <th>Email</th>
            <th>Access Control</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => {
            return (
              <tr key={user.id} onClick={() => openUserDetail(user.id)} className="cursor-pointer">
                <th>{index + 1}</th>
                <td>{user?.firstName}</td>
                <td>{user?.lastName}</td>
                <td>{user?.email}</td>
                <td>
                  <div className="badge badge-error gap-2 font-medium">
                    {user?.accessRole?.name}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Flexbox>
  )
}

export default UsersScreen